/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Nav_TrophiesInputs */

const en_control_nav_trophies = /** @type {(inputs: Control_Nav_TrophiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trophies`)
};

const zh_control_nav_trophies = /** @type {(inputs: Control_Nav_TrophiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`奖杯`)
};

/**
* | output |
* | --- |
* | "Trophies" |
*
* @param {Control_Nav_TrophiesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_nav_trophies = /** @type {((inputs?: Control_Nav_TrophiesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Nav_TrophiesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_nav_trophies(inputs)
	return zh_control_nav_trophies(inputs)
});
export { control_nav_trophies as "control.nav.trophies" }